'use client';

import { useEffect, useState } from 'react';

/**
 * Grid-free pages' own `?grid` drawing layer (the /about §5 conceit, shared):
 * with `?grid` in the query string a pointer-transparent overlay paints the
 * page's brand-tinted 72px drawing layer — lattice, the two 16-col container
 * edges, and numbered columns — plus a fixed close button.
 *
 * Deliberately hard-coded to the 72px / 1152px (16×72) centered lattice from
 * the prototypes, NOT the responsive HeroGrid vars: grid-free pages run
 * `GridOff` (which suppresses the site-wide grid + the `html.grid-debug`
 * blue lines), so this overlay is their only drawing layer. Desktop-only.
 * Mount it last inside the page's `relative` wrapper so `absolute inset-0`
 * spans the document.
 */

const COLS = Array.from({ length: 17 }, (_, n) => n);

export default function PageGridOverlay() {
  const [debug, setDebug] = useState(false);

  useEffect(() => {
    if (/[?&]grid\b/.test(window.location.search)) setDebug(true);
  }, []);

  if (!debug) return null;

  return (
    <>
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 z-[80] hidden md:block"
        style={{
          backgroundImage:
            'linear-gradient(color-mix(in srgb,var(--color-brand-600) 22%,transparent) 1px,transparent 1px),linear-gradient(90deg,color-mix(in srgb,var(--color-brand-600) 22%,transparent) 1px,transparent 1px)',
          backgroundSize: '72px 72px',
          backgroundPosition: 'calc(50% - 576px) 0',
        }}
      >
        <span className="absolute inset-y-0 left-[calc(50%-576px)] w-px bg-[color-mix(in_srgb,var(--color-brand-600)_45%,transparent)]" />
        <span className="absolute inset-y-0 left-[calc(50%+575px)] w-px bg-[color-mix(in_srgb,var(--color-brand-600)_45%,transparent)]" />
        {COLS.map((n) => (
          <span
            key={n}
            className="absolute top-1.5 -translate-x-1/2 rounded-[3px] bg-brand-600 px-1 py-px font-jetbrains text-[9px] text-white"
            style={{ left: `calc(50% - 576px + ${n * 72}px)` }}
          >
            {n}
          </span>
        ))}
      </div>
      <button
        type="button"
        onClick={() => setDebug(false)}
        className="fixed bottom-4 left-4 z-[90] hidden cursor-pointer rounded-ref-sm border border-white/20 bg-ink px-[13px] py-[9px] font-jetbrains text-[11px] text-white shadow-[0_14px_40px_-16px_#101028aa] md:block"
      >
        ?grid &mdash; 72px cells &middot; 16-col container &middot; click to close
      </button>
    </>
  );
}
